import { useEffect, type RefObject } from 'react';

const FOCAVEIS = [
  'button:not([disabled]):not([tabindex="-1"])',
  '[href]:not([tabindex="-1"])',
  'input:not([disabled]):not([tabindex="-1"])',
  '[tabindex]:not([tabindex="-1"])'
].join(', ');

/**
 * Prende o Tab dentro de `ref` enquanto `ativo`. Foco inicial no elemento que casa
 * com `inicial` (ex.: `[data-foco-inicial]`), ou no primeiro focável.
 */
export function usePrenderFoco(ref: RefObject<HTMLElement | null>, ativo: boolean, inicial?: string) {
  useEffect(() => {
    if (!ativo) return;
    const el = ref.current; if (!el) return;
    const alvos = () => [...el.querySelectorAll<HTMLElement>(FOCAVEIS)];
    ((inicial && el.querySelector<HTMLElement>(inicial)) || alvos()[0])?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Tab') return;
      const f = alvos(); if (!f.length) return;
      e.preventDefault();
      const a = document.activeElement as HTMLElement | null;
      let i = a ? f.indexOf(a) : -1;
      if (i < 0 && a && el.contains(a)) {
        // O foco está num elemento fora da lista (o painel com tabindex=-1):
        // o próximo é o primeiro focável depois dele no documento.
        const depois = f.findIndex(x => a.compareDocumentPosition(x) & Node.DOCUMENT_POSITION_FOLLOWING);
        const k = depois < 0 ? f.length : depois;
        f[e.shiftKey ? (k - 1 + f.length) % f.length : k % f.length].focus();
        return;
      }
      f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
    };
    el.addEventListener('keydown', onKey);
    return () => el.removeEventListener('keydown', onKey);
  }, [ref, ativo, inicial]);
}
